/* import __COLOCATED_TEMPLATE__ from './language-filter-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();